'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';

interface LogoProps {
  src: string;
  alt: string;
  className: {
    link?: string;
    image: string;
  };
}

export function Logo({ src, alt, className }: LogoProps) {
  return (
    <Link
      prefetch={false}
      href={ROUTES.HOME()}
      className={cn(
        'inline-flex min-w-0 max-w-full cursor-pointer transition-all ease-in-out hover:opacity-75',
        className?.link,
      )}
    >
      <Image
        src={src}
        alt={alt}
        width={0}
        height={0}
        className={cn('max-w-full shrink object-contain object-center', className?.image)}
        sizes="100vw"
      />
    </Link>
  );
}
